let options = document.getElementsByName("variant");
const itemID = document.getElementById("item-id");
const itemSubmit = document.getElementById("item-submit");
//###########################################################
// AB test
"use strict";
function selectorABTest () {
  if (window.getComputedStyle(document.querySelector("#form-addtocart--ab-test")).display != "none") {
    let colorSeleted = null;
    let sizeSelected = null;
    const colorContainer = "product__color-container";
    const sizeContainer = "product__size-container";
    const selectOptions = "variant-options_selected";
    const allSizes = ".product__size-container_input";
    const productFormOpen = "product-form--open";

    //variables
    var messageDisable = "Select Color and Size";

    // Get the first item
    document.getElementById(productFormOpen).addEventListener("click", () => {
      let firstItem = document.getElementById(colorContainer).querySelector('input');
      colorSeleted = firstItem.value;
      let allColorsItems = document.getElementById(colorContainer).querySelectorAll('input');
      if ( allColorsItems.length == 1 ){
        messageDisable = "Select Size";
      }
      // Uncomment if you wish to deselect sizes when changing color
      //sizeSelected = "none";
      //document.querySelectorAll(allSizes).forEach(function (size) { size.checked = false })

      if (colorSeleted) {
        document.querySelector('.color-name').innerText = colorSeleted;
      } else {
        document.querySelector('.color-name').innerText = "";
      }
      updateVariantName(sizeSelected, colorSeleted);
      checkAvailableSizes(colorSeleted);
    })
    
    // Get the item clicked
    document.getElementById(colorContainer).addEventListener("click", (color) => {
      colorSeleted = color.target.value;
      // Uncomment if you wish to deselect sizes when changing color
      //sizeSelected = "none";
      //document.querySelectorAll(allSizes).forEach(function (size) { size.checked = false })

      if (colorSeleted) {
        document.querySelector('.color-name').innerText = colorSeleted;
      } else {
        document.querySelector('.color-name').innerText = "Not selected";
        document.querySelectorAll('.image-container-input').forEach(function (el) { el.checked = false })
      }
      updateVariantName(sizeSelected, colorSeleted);
      checkAvailableSizes(colorSeleted);
    })

    document.getElementById(sizeContainer).addEventListener("click", (size) => {
      sizeSelected = size.target.value
      if (sizeSelected) {
        // working correctly
      } else {
        sizeSelected = "none";
        document.querySelectorAll(allSizes).forEach(function (size) { size.checked = false })
      }
      updateVariantName(sizeSelected, colorSeleted);
    })
    
    function updateVariantName(sizeSelected, colorSeleted) {
      const selectOptions = "variant-options_selected";

      if (sizeSelected === null) {
        updateColorName(colorSeleted)
      } else {
        let variantName = `${colorSeleted} / ${sizeSelected}`;
        for (let i = 0; i < document.getElementById(selectOptions).options.length; i++) {
          const option = document.getElementById(selectOptions).options[i];
          if (option.text === variantName) {
            const checkAvailable = option.getAttribute("available");
            option.selected = "selected";
            itemID.value = option.value;
            if (checkAvailable === 'true') {
              itemSubmit.disabled = false;
              itemSubmit.value = "Add to Cart";
              document.querySelector('.color-name').style.color= "#000000";            
            } else {
              itemSubmit.disabled = true;
              itemSubmit.value = messageDisable;
            }
            break;
          } else {
            itemSubmit.disabled = true;
            itemSubmit.value = messageDisable;
          }
        }
      }
    }

    function updateSoldOut ( colorSeleted) {
      let selectOptionsEl = document.getElementById(selectOptions);
      let variantName = `${colorSeleted}`;
      let soldOut = true;
      for (let i = 0; i < selectOptionsEl.options.length; i++) {
        const option = selectOptionsEl.options[i];
        if (option.text.split(' / ')[0].trim() === variantName) {
          const checkAvailable = option.getAttribute("available");
          if (checkAvailable === "true") {
            soldOut = false;
            break;
          }
        }
      }
      if (soldOut === true) {
        setSoldOut(colorSeleted);
      }
    }
    
    function setSoldOut( colorSeleted ){
      itemSubmit.disabled = true;
      itemSubmit.getAttribute('data-corner');
      console.log(itemSubmit.getAttribute('data-corner'));
      if (itemSubmit.getAttribute('data-corner') === 'Coming Soon') {
        document.querySelector('.color-name').innerText = colorSeleted + " - Coming Soon";
        itemSubmit.value = "Coming Soon";

      }else {
        document.querySelector('.color-name').innerText = colorSeleted + " - Sold Out";
        itemSubmit.value = "Sold Out";
      }
      document.querySelector('.color-name').style.color= "#505050";
    }

    function updateColorName(colorSeleted) {
      let selectOptionsEl = document.getElementById(selectOptions);
      let variantName = `${colorSeleted}`;
      for (let i = 0; i < selectOptionsEl.options.length; i++) {
        const option = selectOptionsEl.options[i];
        if (option.text === variantName) {
          const checkAvailable = option.getAttribute("available");
          option.selected = "selected";
          itemID.value = option.value;
          if (checkAvailable === 'true') {
            itemSubmit.disabled = false
            itemSubmit.value = "Add to Cart";
            document.querySelector('.color-name').style.color= "#000000";            
          } else {
            setSoldOut( colorSeleted );
          }
          break;
        }
      }
    }
    
    function checkAvailableSizes(colorSeleted) {
      let selectOptionsEl = document.getElementById(selectOptions);
      if (document.querySelectorAll(allSizes).length > 0){
        document.querySelector('.color-name').style.color= "#000000";
      }
      document.querySelectorAll(allSizes).forEach(function (size) {
        const sizeFinded = size.value;
        for (let i = 0; i < selectOptionsEl.options.length; i++) {
          const option = selectOptionsEl.options[i];
          if (option.text === `${colorSeleted} / ${sizeFinded}`) {
            const checkAvailable = option.getAttribute("available");
            if (checkAvailable === 'false') {
              size.disabled = true
              itemSubmit.value = messageDisable;
              itemSubmit.disabled = true;
              updateSoldOut(colorSeleted);
            } else {
              size.disabled = false;
            }
            break;
          }
        }
      });
    }
    
    updateVariantName();
  }

  function preventScrolling() {
    if (window.getComputedStyle(document.querySelector("#form-addtocart--ab-test")).display != "none") {
      document.body.style.overflow = "hidden";

    }
  }

  function activateScrolling() {
    if (window.getComputedStyle(document.querySelector("#form-addtocart--ab-test")).display != "none") {
      document.body.style.overflow = "visible";
    }
  }


  // ###################################################################


  options.forEach((option) => option.addEventListener("change", () => {
    itemID.value = option.value;
    itemSubmit.disabled = false;
  }));
  const productForm = document.getElementById("product-form--container");
  const productFormBackdrop = document.getElementById("product-form--backdrop");
  const productFormOpen = document.getElementById("product-form--open");
  const productFormClose = document.getElementById("product-form--close");
  productFormOpen.addEventListener("click", function(event) {
    event.stopPropagation();
    productFormBackdrop.classList.toggle("open");
    productForm.classList.toggle("open");
    preventScrolling();
  });
  productFormClose.addEventListener("click", function(event) {
    event.stopPropagation();
    productFormBackdrop.classList.remove("open");
    productForm.classList.remove("open");
    activateScrolling();

  });
  document.addEventListener("click", function(event) {
    if (!productForm.contains(event.target) && productForm.classList.contains("open")) {
      productFormBackdrop.classList.remove("open");
      productForm.classList.remove("open");
      activateScrolling();
    }
  });
  let accordions = document.getElementsByClassName("accordion");
  for (i = 0; i < accordions.length; i++) {
    accordions[i].addEventListener("click", function() {
      this.classList.toggle("active");
      let panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
}

selectorABTest();
if (document.querySelector('#product__color-container')) {
  const swiper = new Swiper('#product__color-container', {
    slidesPerView: "auto",
    spaceBetween: 10,
    mousewheel: true,
    allowTouchMove: true,
    freeMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });
}
